// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"9c0f440e","54":"e26ea701","87":"1597ae5c","168":"fd896f2b","206":"a63b2113","451":"03d4b906","729":"d5c6169d","818":"1483cdf9"}[chunkId] + ".chunk.js";
};